import { ReportType } from "../typings/global";
import Console from "../utils/console";
import tools from "../utils/tools";
import Logger from "./logger";

const guid = tools.generateGuid();

export default class Collecter {
  logs: any[];
  comDimInfo: Object;
  comFieldInfo: Object;
  baseInfo: ReportType.BaseInfo;
  console: Console;

  constructor() {
    this.logs = [];
    this.baseInfo = { ua: "", uid: 0 };
    this.comDimInfo = {};
    this.comFieldInfo = {};
    this.console = new Console();
  }

  /** 设置配置 */
  setConfig(config: ReportType.GConfig) {
    this.console.setConfig(config);
    const { BaseInfo, DefDimInfo, DefFieldInfo } = config || {};
    if (BaseInfo) {
      Object.assign(this.baseInfo, BaseInfo);
    }
    if (DefDimInfo) {
      Object.assign(this.comDimInfo, DefDimInfo);
    }
    if (DefFieldInfo) {
      Object.assign(this.comFieldInfo, DefFieldInfo);
    }
  }

  /**
   * 添加日志
   */
  add(log: Logger) {
    log.prefixDim(this.comDimInfo);
    log.prefixField(this.comFieldInfo);

    const data = log.toJSON();
    this.console.log("add log", data);
    this.logs.push(data);
    return this;
  }

  /**
   * 收集数据
   */
  collect() {
    if (!this.logs.length) {
      return null;
    }

    const { sguid, ua, uid } = this.baseInfo;
    return {
      ua: ua || "",
      uid: uid || 0,
      sguid: sguid || guid,
      m: this.logs,
    };
  }

  /**
   * 清除日志
   */
  clear() {
    this.logs = [];
    return this;
  }
}
